import { useFetcher } from '@remix-run/react';

interface CookieBannerProps {
  hasConsented: boolean;
}

export const CookieBanner = ({ hasConsented }: CookieBannerProps) => {
  const fetcher = useFetcher<{ ok: boolean }>();

  if (hasConsented || fetcher.data?.ok) {
    return null;
  }

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 border-t border-gray-200 bg-white shadow-lg">
      <div className="mx-auto max-w-7xl px-4 py-4 sm:px-6 lg:px-8">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-sm text-gray-700">
            We use cookies for analytics and authentication. By using Dewdrop, you agree to our use of cookies.
          </p>
          <fetcher.Form method="post" action="/api/cookie-consent">
            <button
              type="submit"
              disabled={fetcher.state === 'submitting'}
              className="inline-flex items-center rounded-md bg-black px-4 py-2 text-sm font-medium text-white hover:bg-gray-800 disabled:opacity-50 disabled:cursor-not-allowed transition-colors whitespace-nowrap"
            >
              Accept Cookies
            </button>
          </fetcher.Form>
        </div>
      </div>
    </div>
  );
};
